import { Trans } from '@lingui/react/macro';

import type { IntegrationProviderCategory } from '@/api/integration';
import { ColorBadge } from '@/components/typography';
import { COLOR_AQUA_600, COLOR_BLUE_500, COLOR_PINK_400 } from '@/styles/palette';

type Props = {
  category: IntegrationProviderCategory;
};

const IntegrationCategoryTag = ({ category }: Props) => {
  if (category === 'crm') {
    return (
      <ColorBadge textColor="light" color={COLOR_BLUE_500}>
        <Trans>CRM</Trans>
      </ColorBadge>
    );
  }

  if (category === 'advertising') {
    return (
      <ColorBadge textColor="light" color={COLOR_AQUA_600}>
        <Trans>Ads</Trans>
      </ColorBadge>
    );
  }

  if (category === 'ai') {
    return (
      <ColorBadge textColor="light" color={COLOR_PINK_400}>
        <Trans>AI</Trans>
      </ColorBadge>
    );
  }

  return null;
};

export default IntegrationCategoryTag;
